import api, { formatApiError } from "./api";
import { toast } from "sonner";

export const COUNCIL_ID = "consiliu";

export const RECIPIENTS = [
  ["buffett", "Warren Buffett"],
  ["jobs", "Steve Jobs"],
  ["bezos", "Jeff Bezos"],
  [COUNCIL_ID, "Toti 3 impreuna"],
];

const newRoundId = () =>
  (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

export async function createThread({ consultantId, title, question }) {
  const { data } = await api.post("/api/ai-board/threads", { consultant_id: consultantId, title: title || null, question });
  return data;
}

// Trimite o runda (intrebare initiala sau raspuns) catre 1 sau 3 consultanti + sinteza la consiliu.
export async function runRound({ threadId, recipient, consultantIds, question, attachmentIds = [], src, sessions = {}, onSynthStart }) {
  const roundId = newRoundId();
  const targets = recipient === COUNCIL_ID ? consultantIds : [recipient];
  const msgs = [];
  const newSessions = {};
  for (const id of targets) {
    try {
      const { data } = await api.post("/api/ai-board/ask", {
        consultant_id: id,
        question,
        session_id: sessions[id] || null,
        thread_id: threadId,
        round_id: roundId,
        attachment_ids: attachmentIds,
        sources: src.sources,
        date_from: src.date_from || null,
        date_to: src.date_to || null,
      });
      newSessions[id] = data.session_id;
      msgs.push({ role: "ai", consultant: data.consultant_name, text: data.answer, ts: Date.now() });
    } catch (err) {
      const httpStatus = err?.response?.status;
      const detail = err?.response?.data?.detail
        || (httpStatus === 504 || !err?.response ? "Timp de raspuns depasit. Reduceti perioada sau sursele." : undefined);
      toast.error(formatApiError(detail) || "Eroare LLM");
      msgs.push({ role: "error", text: `${id}: ${typeof detail === "string" ? detail : "Eroare"}`, ts: Date.now() });
    }
  }
  const ok = msgs.filter((m) => m.role === "ai").map((m) => ({ consultant_name: m.consultant, answer: m.text }));
  if (recipient === COUNCIL_ID && ok.length >= 2) {
    onSynthStart?.();
    try {
      const { data } = await api.post("/api/ai-board/synthesis", { question, answers: ok, thread_id: threadId, round_id: roundId });
      msgs.push({ role: "ai", consultant: "Concluzie comuna", text: data.answer, ts: Date.now(), synthesis: true });
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Sinteza esuata");
    }
  }
  return { msgs, newSessions };
}
